import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  noContactHeading: false,
  openContact: false,
  simpleMode: false,
}

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
   setNoHeading: (state, action) =>  {
    state.noContactHeading = action.payload
   },
   setOpnContact: (state, action) => {
    state.openContact = action.payload
   },
   setSimpleMode: (state, action) => {
    state.simpleMode = action.payload
   }
  },
})

export const { setNoHeading, setOpnContact, setSimpleMode } = globalSlice.actions
export const selectHeading = (state) => state.global.noContactHeading;
export const selectContact = (state) => state.global.openContact
export const selectSimpleMode = (state) => state.global.simpleMode
export default globalSlice.reducer